import IconBase from "./IconBase";

const LayersIcon = props => (
  <IconBase {...props}>
    <g
      transform="translate(2, 2.5)"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    >
      <path d="M9.185.518l5.768 2.524c.253.111.368.406.258.659a.5.5 0 0 1-.258.258L9.185 6.482c-.49.214-.669.27-.877.306a1.747 1.747 0 0 1-.616 0c-.208-.037-.387-.092-.877-.306L1.047 3.958a.5.5 0 0 1 0-.916l5.768-2.524c.49-.214.669-.27.877-.306.209-.036.407-.036.616 0 .208.037.387.092.877.306z" />
      <path d="M15 7.5l-6.167 2.753c-.356.159-.48.2-.623.227a1.097 1.097 0 0 1-.42 0c-.143-.027-.267-.068-.623-.227L1 7.5" />
      <path d="M15 11.5l-6.167 2.753c-.356.159-.48.2-.623.227a1.097 1.097 0 0 1-.42 0c-.143-.027-.267-.068-.623-.227L1 11.5" />
    </g>
  </IconBase>
);

export default LayersIcon;
